module.exports = __webpack_public_path__ + "static/media/post-05.3858b3fb.jpg";